<router-outlet></router-outlet>

<!-- Shared toast surface — severity class selects the visual variant (error box vs success pill).
Driven by UiService.errorStream; see announceError / announceCopied. -->
<div
  id="error-display"
  [ngClass]="{ show: showError, hide: hideError }"
  [class.success]="toastSeverity === 'success'"
  [class.sticky]="toastSticky"
>
  @if (toastSeverity === 'success') {
    <svg lucideCheck></svg>
    <span>{{ errorMessage }}</span>
  } @else {
    <div class="error-header-row">
      <div class="error-heading">{{ errorHeading }}</div>
      @if (toastSticky) {
        <button type="button" class="toast-close-btn" (click)="dismissToast()" aria-label="Dismiss notification">
          <svg lucideX></svg>
        </button>
      }
    </div>
    <div>{{ errorMessage }}</div>
  }
</div>
